import { FOOTER_GROUPS } from "../data/siteLinks";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative py-12 border-t border-white/10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav
          aria-label="Site links"
          className="grid grid-cols-2 md:grid-cols-5 gap-x-6 gap-y-8 text-sm"
        >
          {FOOTER_GROUPS.map((group) => (
            <div key={group.title}>
              <h2 className="text-sm font-medium text-white mb-3">{group.title}</h2>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      {...(link.newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                      className="text-gray-400 hover:text-teal-400 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
        <div className="mt-10 pt-6 border-t border-white/10 flex items-center gap-3">
          <img src="/rareWorks.webp" alt="RareWorks" className="h-10 w-auto rounded-lg" />
          <span className="text-gray-400 text-sm">© {currentYear} Rare Works, Columbia, MS</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
